import React from 'react';

import Box from '@ui/box/Box.tsx';

import BuildingsList from './subComponents/BuildingsList.tsx';
import Trigger from './subComponents/Trigger.tsx';

// ======================
// BuildingLevelSelector
// ======================
const BuildingLevelSelectorDesktop = ({ ref, ...props }) => {
  const {
    buildings,
    selectedBuildingId,
    selectedLevelId,
    onBuildingClick,
    onLevelClick,
    currentBuildingName,
    currentLevelName,
    fallbackBuildingName,
    fallbackLevelName,
    isExpanded,
    onTriggerClick,
    withSearchResults,
    tooltipContent,
    'data-testid': dataTestId = 'BuildingLevelSelector',
    T,
  } = props;

  return (
    <Box ref={ref} display="flex" flexDirection="column" width="180px" height="100%" data-testid={dataTestId}>
      <Trigger
        currentBuildingName={currentBuildingName}
        currentLevelName={currentLevelName}
        fallbackBuildingName={fallbackBuildingName}
        fallbackLevelName={fallbackLevelName}
        onTriggerClick={onTriggerClick}
        isExpanded={isExpanded}
        withSearchResults={withSearchResults}
        tooltipContent={tooltipContent}
        paddingBottom="16px"
        T={T}
      />

      {isExpanded && (
        <BuildingsList
          levelSelectorRef={ref}
          buildings={buildings}
          selectedBuildingId={selectedBuildingId}
          selectedLevelId={selectedLevelId}
          onBuildingClick={onBuildingClick}
          onLevelClick={onLevelClick}
          T={T}
        />
      )}
    </Box>
  );
};

BuildingLevelSelectorDesktop.displayName = 'Building Level Selector';

export default BuildingLevelSelectorDesktop;
